import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

/**
 * enums
*/
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';

/**
 * services
*/
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

/**
 * interfaces
*/
import { IAdvertisementResponse, IPlaningZoneResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * models & helpers
 */
import Pagination from 'src/app/core/classes/pagination';
import { scrollToElement } from 'src/app/core/funcations-helper/Dom/scroll-to-element';

@Component({
  selector: 'app-advertisement-plan-zones',
  templateUrl: './advertisement-plan-zones.component.html',
  styleUrls: ['./advertisement-plan-zones.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementPlanZonesComponent implements OnInit {

  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'advertisementData', required: true }) public AdvertisementData: IAdvertisementResponse = null;

  /**
   * classList
   */
  @Input({ alias: 'classList' }) public ClassList: string;

  /************  Fields  ************/
  /**
   * @description to show all lands in that zone
   * @returns current zone that user select it
   */
  public ActiveZone: IPlaningZoneResponse = null;

  /**
   * 
   */
  private _landsPagination: Pagination<IAdvertisementResponse> = new Pagination(5, 0, 1, null);
  
  
  /************  Accessors  ************/
  /**
   * @description return planing zones
   */
  public get Zones(): IAdvertisementResponse['zones'] {
    
    /**
     * handler nullable value
     */
    if (Array.isArray(this.AdvertisementData?.zones)) return this.AdvertisementData.zones

    return []

  }

  /**
   * @description page pagination limit
   */
  public get Limit(): number {
    return this._landsPagination.limit
  }

  /**
   * @description total items
   */
  public get TotalCount(): number {
    return this._landsPagination.totalCount
  }
  
  /**
   * @description current page pagination
   */
  public get CurrentPage(): number {
    return this._landsPagination.currentPage
  }  

  /**
   * @description return planing lands
   */
  public get Lands(): IAdvertisementResponse[] {
    
    /**
     * handler nullable value
     */
    if (Array.isArray(this._landsPagination.items)) return this._landsPagination.items

    return []

  }

  /**
   * @description http loading while get lands
   */
  public get IsLoading(): BehaviorSubject<boolean> {
    return this._landsPagination.isLoading
  }

  /**
   *
   */
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _api: ApiResponseService,
  ) {}

  /************  Life Cycle  ************/
  /**
   * 
   */
  ngOnInit(): void {

    /**
     * 
     */
    this._landsPagination.callBack = this._paginationCallback.bind(this);

  }

  /**
   * 
   * @param params 
   * @returns 
   */
  private _paginationCallback(params: Params) {

    /**
     * scroll to view
     */
    scrollToElement('zoneDetails')

    /**
     * 
     */
    return this._api.findAllAdvertisementUnits(this.AdvertisementData?.id, { params: {...params, zoneId: this.ActiveZone.id} })

  }

  /**
   * 
   * @param page 
   */
  public PageChange(page: number): void {

    this._landsPagination.pageChange(page)

  }


  /**
   * 
   * @param zoneId 
   * @returns 
   */
  public GetLandsByZone(zoneId: number): void {

    /**
     * handler nullable value
     */
    if (zoneId == null) {
      new Error("zoneId is null")
      return;
    }

    /**
     * prevent
     */
    if (zoneId == this.ActiveZone?.id) return;

    /**
     * 
     */
    this._getZoneDetails(zoneId);

    /**
     * reset current page with each new zone
     */
    this._landsPagination.currentPage = 1;

    /**
     * get lands
     */
    this._landsPagination.initCallback({ zoneId, [RANDOM_VALUE.loader]: true })
    

  }

  /**
   * 
   * @param zoneId
   * @description set zone object at ActiveZone
   */
  private _getZoneDetails(zoneId: number): void {

    /**
     * handler nullable value
     */
    if (zoneId == null) {
      new Error("zoneId is null")
      return;
    }

    /**
     * 
     */
    this.ActiveZone = this.Zones.find(zone => zone.id == zoneId)

  }

}
